
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchLightPerfDate,
  dispatchLightPerfDevice,
  dispatchLightPerfScene,
  dispatchLightPerfSubtype,
  dispatchLightPerfLog,
  dispatchLightResource,
  dispatchLightJank,
  dispatchLightMethod,
  dispatchLightPerfTrend,
  dispatchLightPerfFunctions,
  dispatchLightPerfDateContrast,
  dispatchLightPerfResourceCost,
  dispatchLightPerfJankCost,
  dispatchLightPerfMethodCost,
  dispatchLightPerfUrl,
  dispatchAndroidAppFileUrl,
  dispatchDeleteLight,
  dispatchLightPerfEditLog,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetLightPerfDate,
  readGetLightPerfDevice,
  readGetLightPerfScene,
  readGetLightPerfSubtype,
  readGetLightPerfLog,
  readGetLightPerfResource,
  readGetLightPerfJank,
  readGetLightPerfMethod,
  readGetLightPerfFunctions,
  readGetLightPerfTrend,
  readGetLightPerfUrl,
  readGetLightPerfDateContrast,
  readGetLightPerfResourContrast,
  readGetLightPerfJankContrast,
  readGetLightPerfMethodContrast,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public async mounted() {
    this.data_type = "Battle";
    await dispatchLightPerfDate(store, {
      project: this.localProject,
      data_type: this.data_type,
    });
    this.filterList.date = readGetLightPerfDate(store)[0].date;
    await dispatchLightPerfDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
      data_type: this.data_type,
    });
    
    const option = readGetLightPerfDevice(store).find(item => item.name.includes('J200')) || readGetLightPerfDevice(store)[0]
    this.filterList.device = option?.device_id;

    await dispatchLightPerfScene(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      data_type: this.data_type,
    });
    this.filterList.scene = readGetLightPerfScene(store)[0].id;
    await dispatchLightPerfSubtype(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      data_type: this.data_type,
    });
    this.filterList.subtype = readGetLightPerfSubtype(store)[0].subtype;
    await dispatchLightPerfLog(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
      data_type: this.data_type,
    });

    this.filterList.Journa = readGetLightPerfLog(store)[0].id_test;
    await dispatchLightPerfDateContrast(store, {
      project: this.localProject,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
      data_type: this.data_type,
    });

    //this.filterList.dateResource.push(this.filterList.date);
    this.filterList.dateResource.push(this.lightPerfDateContrast?.[0]?.date)
    this.filterList.dateMethod.push(this.lightPerfDateContrast?.[0]?.date)
    this.filterList.dateJank.push(this.lightPerfDateContrast?.[0]?.date)

    await dispatchLightResource(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
      data_type: this.data_type,
    });
    await dispatchLightPerfResourceCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
      data_type: this.data_type,
    });
    await dispatchLightJank(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.jank_input,
      size: this.record,
      page: this.currentPage2,
      data_type: this.data_type,
    });
    await dispatchLightPerfJankCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateJank,
      data_type: this.data_type,
    });
    await dispatchLightMethod(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.method_input,
      size: this.record,
      page: this.currentPage3,
      data_type: this.data_type,
    });
    await dispatchLightPerfMethodCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateMethod,
      data_type: this.data_type,
    });

    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.JankTable.results = this.jankList.list.slice(
      (this.currentPage6 - 1) * 10,
      this.currentPage6 * 10
    );
    this.MethodTable.results = this.methodList.list.slice(
      (this.currentPage5 - 1) * 10,
      this.currentPage5 * 10
    );

    await dispatchLightPerfFunctions(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      data_type: this.data_type,
    });
    this.filterList.trendOp = this.lightPerfFunctions?.default;
    await dispatchLightPerfUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchLightPerfTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      functions: this.filterList.trendOp,
      data_type: this.data_type,
    });
    await this.drawTrend();
  }
  public get resourceList() {
    return readGetLightPerfResourContrast(store);
  }
  public get methodList() {
    return readGetLightPerfMethodContrast(store);
  }
  public get jankList() {
    return readGetLightPerfJankContrast(store);
  }
  public get lightUrl() {
    return readGetLightPerfUrl(store);
  }
  public packageBtn() {
    if (this.lightUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.lightUrl, "_blank");
    }
  }
  public async cost(type) {
    if (type === "jank") {
      this.currentPage6 = 1;
      await dispatchLightPerfJankCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateJank,
        data_type: this.data_type,
      });
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "resource") {
      this.currentPage4 = 1;
      await dispatchLightPerfResourceCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateResource,
        data_type: this.data_type,
      });
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "method") {
      this.currentPage5 = 1;
      await dispatchLightPerfMethodCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateMethod,
        data_type: this.data_type,
      });
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
  }
  public ResourceTable: any = {
    results: [],
    count: 0,
  };
  public MethodTable: any = {
    results: [],
    count: 0,
  };
  public JankTable: any = {
    results: [],
    count: 0,
  };
  public resource_input = "";
  public jank_input = "";
  public method_input = "";
  public record = 10;
  public currentPage1 = 1;
  public currentPage2 = 1;
  public currentPage3 = 1;
  public currentPage4 = 1;
  public currentPage5 = 1;
  public currentPage6 = 1;
  public filterList = {
    date: "",
    device: "",
    scene: "",
    subtype: "",
    Journa: "",
    trendOp: [],
    dateResource: [],
    dateMethod: [],
    dateJank: [],
  };
  public async recordSearch(type) {
    if (type === "resource_input") {
      this.currentPage1 = 1;
      await dispatchLightResource(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.resource_input,
        size: this.record,
        page: this.currentPage1,
        data_type: this.data_type,
      });
    }
    if (type === "jank_input") {
      this.currentPage2 = 1;
      await dispatchLightJank(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.jank_input,
        size: this.record,
        page: this.currentPage2,
        data_type: this.data_type,
      });
    }
    if (type === "method_input") {
      this.currentPage3 = 1;
      await dispatchLightMethod(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.method_input,
        size: this.record,
        page: this.currentPage3,
        data_type: this.data_type,
      });
    }
  }
  public async handleCurrentChange1(type) {
    if (type === "resource_input") {
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "jank_input") {
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "method_input") {
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
  }
  public async handleCurrentChange(type) {
    if (type === "resource_input") {
      await dispatchLightResource(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.resource_input,
        size: this.record,
        page: this.currentPage1,
        data_type: this.data_type,
      });
    }
    if (type === "jank_input") {
      await dispatchLightJank(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.jank_input,
        size: this.record,
        page: this.currentPage2,
        data_type: this.data_type,
      });
    }
    if (type === "method_input") {
      await dispatchLightMethod(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.method_input,
        size: this.record,
        page: this.currentPage3,
        data_type: this.data_type,
      });
    }
  }
  public dialogFormVisible1 = false;
  public logName = "";
  public editBtn() {
    this.logName = this.JournaOptions.filter(
      (v) => v.id_test == this.filterList.Journa
    )[0].time;
    this.dialogFormVisible1 = true;
    //  dispatchLightPerfEditLog(store,{
    //    project:this.localProject,
    //    id_test:this.filterList.Journa,
    //    name:this.logName
    //  })
  }
  public data_type = "";
  public typeOption = ["Battle ", "GameCore"];
  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchLightPerfEditLog(store, {
      project: this.localProject,
      id_test: this.filterList.Journa,
      name: this.logName,
    });

    dispatchLightPerfLog(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
      data_type: this.data_type,
    });
  }
  public get dateOptions() {
    return readGetLightPerfDate(store);
  }
  public get deviceOptions() {
    return readGetLightPerfDevice(store);
  }
  public get sceneOptions() {
    return readGetLightPerfScene(store);
  }
  public get subtypeOptions() {
    return readGetLightPerfSubtype(store);
  }
  public get JournaOptions() {
    return readGetLightPerfLog(store);
  }
  public get lightPerfResource() {
    return readGetLightPerfResource(store);
  }
  public get lightPerfJank() {
    return readGetLightPerfJank(store);
  }
  public get lightPerfmethod() {
    return readGetLightPerfMethod(store);
  }
  public get lightPerfFunctions() {
    return readGetLightPerfFunctions(store);
  }
  public get lightPerfTrend() {
    return readGetLightPerfTrend(store);
  }
  public get lightPerfDateContrast() {
    return readGetLightPerfDateContrast(store);
  }
  public async allOption(item) {
    for (let v of item) {
      if (v === "type_data") {
        await dispatchLightPerfDate(store, {
          project: this.localProject,
          data_type: this.data_type,
        });
        this.filterList.date = readGetLightPerfDate(store)[0].date;
      }
      if (v === "device") {
        await dispatchLightPerfDevice(store, {
          project: this.localProject,
          date: this.filterList.date,
          data_type: this.data_type,
        });

        const defaultOption = readGetLightPerfDevice(store).find(item => item.name.includes('J200')) || readGetLightPerfDevice(store)[0]
        this.filterList.device = defaultOption?.device_id;
      }
      if (v === "scene") {
        await dispatchLightPerfScene(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          data_type: this.data_type,
        });
        this.filterList.scene = readGetLightPerfScene(store)[0].id;
      }
      if (v === "subtype") {
        await dispatchLightPerfSubtype(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          data_type: this.data_type,
        });
        this.filterList.subtype = readGetLightPerfSubtype(store)[0].subtype;
      }
      if (v === "log") {
        await dispatchLightPerfLog(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: Number(this.filterList.subtype),
          data_type: this.data_type,
        });

        this.filterList.Journa = readGetLightPerfLog(store)[0].id_test;
      }
      if (v === "dateContrast") {
        await dispatchLightPerfDateContrast(store, {
          project: this.localProject,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: Number(this.filterList.subtype),
          data_type: this.data_type,
        });
        this.filterList.dateResource = [];
        this.filterList.dateMethod = [];
        this.filterList.dateJank = [];
        this.filterList.dateResource.push(this.filterList.date);
        this.filterList.dateMethod.push(this.filterList.date);
        this.filterList.dateJank.push(this.filterList.date);
        this.currentPage1 = 1;
        this.currentPage2 = 1;
        this.currentPage3 = 1;
        this.currentPage4 = 1;
        this.currentPage5 = 1;
        this.currentPage6 = 1;
      }
    }
    await dispatchLightResource(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
      data_type: this.data_type,
    });
    await dispatchLightPerfResourceCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
      data_type: this.data_type,
    });
    await dispatchLightJank(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.jank_input,
      size: this.record,
      page: this.currentPage2,
      data_type: this.data_type,
    });
    await dispatchLightPerfJankCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateJank,
      data_type: this.data_type,
    });
    await dispatchLightMethod(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.method_input,
      size: this.record,
      page: this.currentPage3,
      data_type: this.data_type,
    });
    await dispatchLightPerfMethodCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateMethod,
      data_type: this.data_type,
    });
    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.JankTable.results = this.jankList.list.slice(
      (this.currentPage6 - 1) * 10,
      this.currentPage6 * 10
    );
    this.MethodTable.results = this.methodList.list.slice(
      (this.currentPage5 - 1) * 10,
      this.currentPage5 * 10
    );
    await dispatchLightPerfFunctions(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      data_type: this.data_type,
    });
    this.filterList.trendOp = this.lightPerfFunctions.default;
    await dispatchLightPerfUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchLightPerfTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      functions: this.filterList.trendOp,
      data_type: this.data_type,
    });
    await this.drawTrend();
  }
  public async allOption1() {
    await dispatchLightPerfTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      functions: this.filterList.trendOp,
      data_type: this.data_type,
    });
    await this.drawTrend();
  }
  public async deleteBtn() {
    await dispatchDeleteLight(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    this.data_type = "Battle";
    await dispatchLightPerfDate(store, {
      project: this.localProject,
      data_type: this.data_type,
    });
    this.filterList.date = readGetLightPerfDate(store)[0].date;
    await dispatchLightPerfDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
      data_type: this.data_type,
    });
    this.filterList.device = readGetLightPerfDevice(store)[0].device_id;
    await dispatchLightPerfScene(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      data_type: this.data_type,
    });
    this.filterList.scene = readGetLightPerfScene(store)[0].id;
    await dispatchLightPerfSubtype(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      data_type: this.data_type,
    });
    this.filterList.subtype = readGetLightPerfSubtype(store)[0].subtype;
    await dispatchLightPerfLog(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
      data_type: this.data_type,
    });

    this.filterList.Journa = readGetLightPerfLog(store)[0].id_test;
    await dispatchLightPerfDateContrast(store, {
      project: this.localProject,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
      data_type: this.data_type,
    });
    this.filterList.dateResource = [];
    this.filterList.dateMethod = [];
    this.filterList.dateJank = [];
    this.filterList.dateResource.push(this.filterList.date);
    this.filterList.dateMethod.push(this.filterList.date);
    this.filterList.dateJank.push(this.filterList.date);
    this.currentPage1 = 1;
    this.currentPage2 = 1;
    this.currentPage3 = 1;
    this.currentPage4 = 1;
    this.currentPage5 = 1;
    this.currentPage6 = 1;
    await dispatchLightResource(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
      data_type: this.data_type,
    });
    await dispatchLightPerfResourceCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
      data_type: this.data_type,
    });
    await dispatchLightJank(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.jank_input,
      size: this.record,
      page: this.currentPage2,
      data_type: this.data_type,
    });
    await dispatchLightPerfJankCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateJank,
      data_type: this.data_type,
    });
    await dispatchLightMethod(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.method_input,
      size: this.record,
      page: this.currentPage3,
      data_type: this.data_type,
    });
    await dispatchLightPerfMethodCost(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateMethod,
      data_type: this.data_type,
    });

    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.JankTable.results = this.jankList.list.slice(
      (this.currentPage6 - 1) * 10,
      this.currentPage6 * 10
    );
    this.MethodTable.results = this.methodList.list.slice(
      (this.currentPage5 - 1) * 10,
      this.currentPage5 * 10
    );

    await dispatchLightPerfFunctions(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      data_type: this.data_type,
    });
    this.filterList.trendOp = this.lightPerfFunctions?.default;
    await dispatchLightPerfUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchLightPerfTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      functions: this.filterList.trendOp,
      data_type: this.data_type,
    });
    await this.drawTrend();
  }
  public drawTrend() {
    let ordinates: any[] = [];
    this.lightPerfTrend.trend_data.params_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: this.lightPerfTrend.trend_data.series[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById("performance_line");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
      },
      xAxis: {
        type: "category",
        data: this.lightPerfTrend.trend_data.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }
}
